import { selectOnboardingData } from '../../../store/slices/user/userSlice'
import { useAppSelector } from '../../../store/utils/hooks'
import { useCallback, useEffect, useState } from 'react'
import { validateEmailAddress } from '../../../utils/Validators/Validators'
import { createUserWithEmailAndPassword, getAuth, deleteUser } from 'firebase/auth'
import { debounce } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { LOGIN_PATH } from '../../../routes/LoginRoutes'

export default function useCheckEmail() {
	const auth = getAuth()
	const navigate = useNavigate()
	const onboardingData = useAppSelector(selectOnboardingData)
	const [userState, setUserState] = useState<{ exist: boolean; loading: boolean }>({ exist: false, loading: false })

	const checkEmailAddress = useCallback(
		debounce(async (email) => {
			try {
				const { user } = await createUserWithEmailAndPassword(auth, email, 'password')
				await deleteUser(user)
				setUserState({ exist: false, loading: false })
			} catch (e: any) {
				if (e.code === 'auth/email-already-in-use') {
					setUserState({ exist: true, loading: false })
				}
			}
		}, 1500),
		[auth],
	)

	useEffect(() => {
		setUserState((prevState) => ({ ...prevState, loading: true }))
		if (validateEmailAddress(onboardingData.email)) {
			checkEmailAddress(onboardingData.email)
		}
	}, [auth, checkEmailAddress, onboardingData.email])

	useEffect(() => {
		if (userState.exist) {
			navigate(`${LOGIN_PATH}/?email=${onboardingData.email}`)
		}
	}, [navigate, onboardingData.email, userState.exist])

	return userState
}
